module.exports = __webpack_public_path__ + "static/media/Imagen_3.73a51c9e.jpg";